import { render, staticRenderFns } from "./CenteredSectionHeader.vue?vue&type=template&id=4681edfb&"
import script from "./CenteredSectionHeader.vue?vue&type=script&lang=js&"
export * from "./CenteredSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports